<markant-platform-group-assignment
  [demoContent]="demoGroups"
></markant-platform-group-assignment>
